import 'whatwg-fetch';

import { BASE_URL } from '../const';
import { mogamboRequestV2, mogamboRequestV3 } from './utils';

export default class SmallTalkAPI {
  constructor(botName, language = 'en') {
    this.botName = botName;
    this.language = language;
  }

  async getAllIntents(botName = this.botName) {
    const url = `${BASE_URL}smalltalk/get_all_intents/${botName}/`;
    const response = mogamboRequestV2(url, 'GET');
    return Promise.resolve(response);
  }

  async getIntent(intentName, botName = this.botName) {
    const url = `${BASE_URL}smalltalk/get_intent_details/${botName}/${intentName}/`;
    const response = await mogamboRequestV3(url, 'GET');
    return Promise.resolve(response);
  }

  async saveIntent(intentName, botSays, botName = this.botName) {
    const url = `${BASE_URL}smalltalk/v2/save_changes/`;
    const params = {
      bot_name: botName,
      intent_name: intentName,
      bot_says: botSays,
    };
    const response = mogamboRequestV3(url, 'POST', params);
    return Promise.resolve(response);
  }

  async enableIntent(intentName, botName = this.botName) {
    const url = `${BASE_URL}smalltalk/enable_intent/`;
    const response = mogamboRequestV2(url, 'POST', {
      bot_name: botName,
      intent_name: intentName,
    });
    return Promise.resolve(response);
  }

  async disableIntent(intentName, botName = this.botName) {
    const url = `${BASE_URL}smalltalk/disable_intent/`;
    const response = mogamboRequestV2(url, 'POST', {
      bot_name: botName,
      intent_name: intentName,
    });
    return Promise.resolve(response);
  }

  async enableAllIntents(botName = this.botName) {
    const url = `${BASE_URL}smalltalk/enable_all_intents/`;
    const response = mogamboRequestV2(url, 'POST', {
      bot_name: botName,
    });
    return Promise.resolve(response);
  }

  async disableAllIntents(botName = this.botName) {
    const url = `${BASE_URL}smalltalk/disable_all_intents/`;
    const response = mogamboRequestV2(url, 'POST', {
      bot_name: botName,
    });
    return Promise.resolve(response);
  }

  async getDetails(botName = this.botName) {
    const url = `${BASE_URL}smalltalk/bot_details/${botName}/`;
    const response = mogamboRequestV2(url, 'GET');
    return Promise.resolve(response);
  }
}
